<template>
	<div class="container">
		<div class="card m-5">
			<div class="card-header text-center">
				{{ game.name }}
			</div>
			<div class="card-body row px-5">
				<dl v-if="game.age" class="col-12 col-md-6">
					<dt class="d-inline mr-2">Возраст:</dt>
					<dd class="d-inline">{{ game.age.join(', ') }}</dd>
				</dl>
				<dl v-if="game.season" class="col-12 col-md-6">
					<dt class="d-inline mr-2">Сезон:</dt>
					<dd class="d-inline">{{ game.season.join(', ') }}</dd>
				</dl>
				<dl v-if="game.activity" class="col-12 col-md-6">
					<dt class="d-inline mr-2">Физическая активность:</dt>
					<dd class="d-inline">{{ game.activity[0] }}</dd>
				</dl>
				<dl v-if="game.development" class="col-12 col-md-6">
					<dt class="d-inline mr-2">Область развития:</dt>
					<dd class="d-inline">{{ game.development.join(', ') }}</dd>
				</dl>
				<dl v-if="game.topics && game.topics[0]" class="col-12 col-md-6">
					<dt class="d-inline mr-2">Тематика:</dt>
					<dd class="d-inline">{{ game.topics.join(', ') }}</dd>
				</dl>
				<dl v-if="game.goals" class="col-12 col-md-6">
					<dt class="d-inline mr-2">Цели и задачи:</dt>
					<dd class="d-inline">{{ game.goals }}</dd>
				</dl>
				<dl v-if="game.numOfParticipants" class="col-12 col-md-6">
					<dt class="d-inline mr-2">Количество участников:</dt>
					<dd class="d-inline">{{ game.numOfParticipants }}</dd>
				</dl>
				<dl v-if="game.additional" class="col-12 col-md-6">
					<dt>Доп. параметры (оборудование, словесное/музыкальное сопровождение):</dt>
					<dd>{{ game.additional }}</dd>
				</dl>

				<!-- <h4 class="mt-5">Ход игры</h4> --><p class="col-12 mt-2"></p>
				<p v-for="(p,i) in game.scenario" :key="i" class="col-12">{{p}}</p>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        props: {
            game: Object
        }
    };
</script>

<style scoped>
	.card, .card-header {
		border-radius: 10px 10px 0 0;
	}
	.card-header {
		font-size: 1.5rem;
		background-color: #fbe793ff;
	}
	p {
		text-align: justify;
		/* margin-top: 1rem; */
		margin-bottom: 0rem;
	}
	dl {
		margin-bottom: 0.2rem;
	}
</style>
